// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2e0dc","row":"Node_row__2cxu6","label":"Node_label__3RJAG","footer":"Node_footer__1sjCw"};